var _defs, _rect, _path, _g, _g2, _g3, _path2, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "77 53 260 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #429e76;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: currentColor;\n      }\n\n      .cls-3 {\n        fill: #e6eae7;\n      }\n\n      .cls-4 {\n        fill: #a1d0bb;\n      }\n\n      .cls-5 {\n        fill: #231f20;\n      }\n\n      .cls-6 {\n        fill: #aa84b9;\n      }\n\n      .cls-7 {\n        fill: #522747;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -8.64,
    y: 209.54,
    width: 437.24,
    height: 218.37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.63,59.23h27.47v42.39h-27.47c-5.32,0-9.64-4.32-9.64-9.64v-23.11c0-5.32,4.32-9.64,9.64-9.64Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.3,105.07v16.24c-8.83-1.1-15.82-7.79-16.95-16.24h16.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.01,106.9l-14.33,2.12c-.01-.32-.02-.65-.02-.97v-1.81l7.97-1.18h6.05c.09.62.2,1.23.33,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.71,112.08l-14.44,5.36c-.3-.87-.56-1.75-.78-2.64l14.23-5.28c.29.88.62,1.73,1,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.45,116.76l-13.27,8.41c-.52-.77-1-1.55-1.45-2.34l13.22-8.37c.46.79.97,1.56,1.51,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.09,120.76l-11.3,11.04c-.67-.64-1.31-1.3-1.92-1.97l11.27-11.01c.62.68,1.27,1.33,1.95,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.47,123.91l-8.93,13.39c-.76-.53-1.51-1.06-2.23-1.61l8.84-13.26c.74.54,1.51,1.03,2.31,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.39,126.09l-6.25,15.68c-.83-.42-1.65-.85-2.45-1.29l6.12-15.37c.83.37,1.69.7,2.57.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.3,127.15v1.96l-2.78,16.22c-.89-.32-1.76-.65-2.62-.99l3.02-17.58c.78.17,1.58.3,2.38.39Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.85,105.07h21.06c-.29,2.23-.81,5.71-1.6,9.01-.82,3.41-2.08,7.05-2.9,9.29-7.69-1.74-13.55-2.54-16.56-2.82v-15.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.49,105.07v2.98c0,.1,0,.2,0,.31-.07,6.44-2.37,12.64-6.51,18.21-.1.14-.21.28-.31.41-2.12-.63-5.54-1.7-6.99-2.08-.03,0-.07-.02-.1-.03,1-1.84,2.4-5.04,3.82-10.32,1.17-4.36,1.64-7.5,1.82-9.49h8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.77,138.26c1.23.28,2.55.61,3.86.96-.32.19-.65.39-.98.58-.1.06-.21.12-.32.18-.3.17-.61.35-.92.52-.11.06-.21.12-.32.18-.52.28-1.04.56-1.58.83-.14.07-.28.14-.42.21-.41.21-.82.41-1.24.61-.19.09-.38.18-.58.27-.2.09-.39.18-.59.27-.14.06-.27.12-.41.18-.23.1-.45.2-.68.3-.25.11-.51.22-.77.33-.58.25-1.17.49-1.76.72-.24.09-.47.19-.71.28-.25.09-.5.19-.75.28-.24.09-.49.18-.73.27,0,0,0,0,0,0-.2.07-.4.14-.6.22-.08.03-.16.06-.24.09-.21.07-.43.15-.64.22-.25.09-.5.17-.76.25-.25.08-.51.17-.76.25v-10.32c3.37.51,6.16.98,11.91,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.15,131.02c-1.6,1.62-3.36,3.17-5.29,4.64-2.32-.7-5.11-1.44-7.54-2.01-6.62-1.53-9.32-1.92-13.48-2.55v-6.14c5.2.8,7.68,1.07,15.13,2.8,3.97.92,8.91,2.31,11.17,3.25Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.88,59.52h2.35v17.43h8.85v1.92h-11.21v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.93,59.52h11.29v1.92h-8.93v6.58h7.2v1.92h-7.2v7.01h9.42v1.92h-11.77v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.02,59.52h3.09l6.55,19.35h-2.33l-1.9-5.58h-7.99l-1.87,5.58h-2.22l6.66-19.35ZM209.1,71.43h6.71l-3.36-9.96-3.36,9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.64,59.52h5.82c3.71,0,6.77,1.52,6.77,5.39v.11c0,3.19-2.14,4.76-4.79,5.28l5.93,8.58h-2.63l-5.77-8.42h-2.98v8.42h-2.35v-19.35ZM231.62,68.58c2.76,0,4.25-1.19,4.25-3.57v-.11c0-2.63-1.62-3.49-4.25-3.49h-3.63v7.17h3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.2,59.52h3.06l9.42,16v-16h2.25v19.35h-2.71l-9.77-16.59v16.59h-2.25v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.5,59.52h2.36v19.35h-2.36v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.43,59.52h3.06l9.42,16v-16h2.25v19.35h-2.71l-9.77-16.59v16.59h-2.25v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294.65,69.32v-.22c0-5.66,3.82-9.88,9.37-9.88,3.84,0,7.28,1.79,7.88,6.14h-2.35c-.54-3.09-2.65-4.28-5.47-4.28-4.44,0-6.98,3.25-6.98,7.99v.22c0,4.79,2.38,7.93,6.93,7.93,4.2,0,6.01-2.73,6.09-6.17h-5.66v-1.95h7.96v1.43c0,5.6-3.44,8.58-8.39,8.58-5.96,0-9.37-4.14-9.37-9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.94,95.23v-.22c0-5.5,3.84-9.83,9.53-9.83s9.45,4.33,9.45,9.77v.22c0,5.47-3.76,9.85-9.39,9.85s-9.58-4.38-9.58-9.8ZM188.47,95.15v-.22c0-4.33-2.54-7.85-7.01-7.85s-7.09,3.3-7.09,7.9v.22c0,4.68,3.11,7.88,7.15,7.88,4.3,0,6.96-3.25,6.96-7.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.24,97.72v-12.29h2.36v12.02c0,4.06,1.43,5.63,4.66,5.63s4.93-1.25,4.93-5.98v-11.67h2.36v11.99c0,4.71-2.36,7.61-7.34,7.61-4.44,0-6.96-2.6-6.96-7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.79,87.35h-5.63v-1.92h13.62v1.92h-5.63v17.43h-2.36v-17.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.67,95.23v-.22c0-5.74,3.84-9.88,9.09-9.88,4.03,0,7.44,2.14,7.85,6.33h-2.33c-.49-2.95-2.19-4.47-5.5-4.47-4.01,0-6.69,3.11-6.69,7.99v.22c0,4.93,2.49,7.9,6.66,7.9,3.17,0,5.36-1.6,5.85-4.74h2.19c-.68,4.47-3.76,6.66-8.09,6.66-5.6,0-9.04-3.84-9.04-9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253,95.23v-.22c0-5.5,3.84-9.83,9.53-9.83s9.45,4.33,9.45,9.77v.22c0,5.47-3.76,9.85-9.39,9.85s-9.58-4.38-9.58-9.8ZM269.54,95.15v-.22c0-4.33-2.54-7.85-7.01-7.85s-7.09,3.3-7.09,7.9v.22c0,4.68,3.11,7.88,7.15,7.88,4.3,0,6.96-3.25,6.96-7.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.47,85.43h3.28l5.98,15.08,5.79-15.08h3.25v19.35h-2.36v-16.3l-6.42,16.3h-.73l-6.63-16.3v16.3h-2.17v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.2,85.43h11.29v1.92h-8.93v6.58h7.2v1.92h-7.2v7.01h9.42v1.92h-11.77v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.96,98.89h2.27c.3,2.3,1.22,4.25,5.12,4.25,2.49,0,4.41-1.46,4.41-3.65s-1-3.11-4.68-3.71c-4.06-.62-6.47-1.9-6.47-5.33,0-2.98,2.57-5.25,6.23-5.25,3.87,0,6.28,1.89,6.66,5.33h-2.11c-.46-2.44-1.87-3.44-4.55-3.44s-4.03,1.33-4.03,3.14.7,2.87,4.66,3.46c4.3.68,6.58,1.98,6.58,5.63,0,3.25-2.84,5.71-6.69,5.71-5.17,0-7.04-2.84-7.39-6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.08,111.35h3.09l6.55,19.35h-2.33l-1.9-5.58h-7.99l-1.87,5.58h-2.22l6.66-19.35ZM176.16,123.26h6.71l-3.36-9.96-3.36,9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.67,121.15v-.22c0-5.74,3.84-9.88,9.09-9.88,4.03,0,7.44,2.14,7.85,6.33h-2.33c-.49-2.95-2.19-4.47-5.5-4.47-4.01,0-6.69,3.11-6.69,7.99v.22c0,4.93,2.49,7.9,6.66,7.9,3.17,0,5.36-1.6,5.85-4.74h2.19c-.68,4.47-3.76,6.66-8.09,6.66-5.6,0-9.04-3.84-9.04-9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.73,111.35h3.09l6.55,19.35h-2.33l-1.9-5.58h-7.99l-1.87,5.58h-2.22l6.66-19.35ZM215.81,123.26h6.71l-3.36-9.96-3.36,9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.35,111.35h5.12c6.66,0,9.8,4.11,9.8,9.5v.24c0,5.36-3.09,9.61-9.85,9.61h-5.06v-19.35ZM237.35,128.78c4.98,0,7.47-2.98,7.47-7.71v-.22c0-4.47-2.17-7.61-7.5-7.61h-2.63v15.54h2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.76,111.35h11.29v1.92h-8.93v6.58h7.2v1.92h-7.2v7.01h9.42v1.92h-11.77v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.64,111.35h3.28l5.98,15.08,5.79-15.08h3.25v19.35h-2.36v-16.3l-6.42,16.3h-.73l-6.63-16.3v16.3h-2.17v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.04,122.26l-6.47-10.91h2.65l5.06,8.99,4.87-8.99h2.35l-6.12,10.94v8.42h-2.36v-8.45Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.63,286.78h27.47v42.39h-27.47c-5.32,0-9.64-4.32-9.64-9.64v-23.11c0-5.32,4.32-9.64,9.64-9.64Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.3,332.62v16.24c-8.83-1.1-15.82-7.79-16.95-16.24h16.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.01,334.46l-14.33,2.12c-.01-.32-.02-.65-.02-.97v-1.81l7.97-1.18h6.05c.09.62.2,1.23.33,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.71,339.63l-14.44,5.36c-.3-.87-.56-1.75-.78-2.64l14.23-5.28c.29.88.62,1.73,1,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.45,344.32l-13.27,8.41c-.52-.77-1-1.55-1.45-2.34l13.22-8.37c.46.79.97,1.56,1.51,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.09,348.32l-11.3,11.04c-.67-.64-1.31-1.3-1.92-1.97l11.27-11.01c.62.68,1.27,1.33,1.95,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.47,351.47l-8.93,13.39c-.76-.53-1.51-1.06-2.23-1.61l8.84-13.26c.74.54,1.51,1.03,2.31,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.39,353.64l-6.25,15.68c-.83-.42-1.65-.85-2.45-1.29l6.12-15.37c.83.37,1.69.7,2.57.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.3,354.7v1.96l-2.78,16.22c-.89-.32-1.76-.65-2.62-.99l3.02-17.58c.78.17,1.58.3,2.38.39Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.85,332.62h21.06c-.29,2.23-.81,5.71-1.6,9.01-.82,3.41-2.08,7.05-2.9,9.29-7.69-1.74-13.55-2.54-16.56-2.82v-15.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.49,332.62v2.98c0,.1,0,.2,0,.31-.07,6.44-2.37,12.64-6.51,18.21-.1.14-.21.28-.31.41-2.12-.63-5.54-1.7-6.99-2.08-.03,0-.07-.02-.1-.03,1-1.84,2.4-5.04,3.82-10.32,1.17-4.36,1.64-7.5,1.82-9.49h8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.77,365.81c1.23.28,2.55.61,3.86.96-.32.19-.65.39-.98.58-.1.06-.21.12-.32.18-.3.17-.61.35-.92.52-.11.06-.21.12-.32.18-.52.28-1.04.56-1.58.83-.14.07-.28.14-.42.21-.41.21-.82.41-1.24.61-.19.09-.38.18-.58.27-.2.09-.39.18-.59.27-.14.06-.27.12-.41.18-.23.1-.45.2-.68.3-.25.11-.51.22-.77.33-.58.25-1.17.49-1.76.72-.24.09-.47.19-.71.28-.25.09-.5.19-.75.28-.24.09-.49.18-.73.27,0,0,0,0,0,0-.2.07-.4.14-.6.22-.08.03-.16.06-.24.09-.21.07-.43.15-.64.22-.25.09-.5.17-.76.25-.25.08-.51.17-.76.25v-10.32c3.37.51,6.16.98,11.91,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.15,358.57c-1.6,1.62-3.36,3.17-5.29,4.64-2.32-.7-5.11-1.44-7.54-2.01-6.62-1.53-9.32-1.92-13.48-2.55v-6.14c5.2.8,7.68,1.07,15.13,2.8,3.97.92,8.91,2.31,11.17,3.25Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.88,287.07h2.35v17.43h8.85v1.92h-11.21v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.93,287.07h11.29v1.92h-8.93v6.58h7.2v1.92h-7.2v7.01h9.42v1.92h-11.77v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.02,287.07h3.09l6.55,19.35h-2.33l-1.9-5.58h-7.99l-1.87,5.58h-2.22l6.66-19.35ZM209.1,298.98h6.71l-3.36-9.96-3.36,9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.64,287.07h5.82c3.71,0,6.77,1.52,6.77,5.39v.11c0,3.19-2.14,4.76-4.79,5.28l5.93,8.58h-2.63l-5.77-8.42h-2.98v8.42h-2.35v-19.35ZM231.62,296.14c2.76,0,4.25-1.19,4.25-3.57v-.11c0-2.63-1.62-3.49-4.25-3.49h-3.63v7.17h3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.2,287.07h3.06l9.42,16v-16h2.25v19.35h-2.71l-9.77-16.59v16.59h-2.25v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.5,287.07h2.36v19.35h-2.36v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.43,287.07h3.06l9.42,16v-16h2.25v19.35h-2.71l-9.77-16.59v16.59h-2.25v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294.65,296.87v-.22c0-5.66,3.82-9.88,9.37-9.88,3.84,0,7.28,1.79,7.88,6.14h-2.35c-.54-3.09-2.65-4.28-5.47-4.28-4.44,0-6.98,3.25-6.98,7.99v.22c0,4.79,2.38,7.93,6.93,7.93,4.2,0,6.01-2.73,6.09-6.17h-5.66v-1.95h7.96v1.43c0,5.6-3.44,8.58-8.39,8.58-5.96,0-9.37-4.14-9.37-9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.94,322.79v-.22c0-5.5,3.84-9.83,9.53-9.83s9.45,4.33,9.45,9.77v.22c0,5.47-3.76,9.85-9.39,9.85s-9.58-4.38-9.58-9.8ZM188.47,322.71v-.22c0-4.33-2.54-7.85-7.01-7.85s-7.09,3.3-7.09,7.9v.22c0,4.68,3.11,7.88,7.15,7.88,4.3,0,6.96-3.25,6.96-7.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.24,325.28v-12.29h2.36v12.02c0,4.06,1.43,5.63,4.66,5.63s4.93-1.25,4.93-5.98v-11.67h2.36v11.99c0,4.71-2.36,7.61-7.34,7.61-4.44,0-6.96-2.6-6.96-7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.79,314.91h-5.63v-1.92h13.62v1.92h-5.63v17.43h-2.36v-17.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.67,322.79v-.22c0-5.74,3.84-9.88,9.09-9.88,4.03,0,7.44,2.14,7.85,6.33h-2.33c-.49-2.95-2.19-4.47-5.5-4.47-4.01,0-6.69,3.11-6.69,7.99v.22c0,4.93,2.49,7.9,6.66,7.9,3.17,0,5.36-1.6,5.85-4.74h2.19c-.68,4.47-3.76,6.66-8.09,6.66-5.6,0-9.04-3.84-9.04-9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253,322.79v-.22c0-5.5,3.84-9.83,9.53-9.83s9.45,4.33,9.45,9.77v.22c0,5.47-3.76,9.85-9.39,9.85s-9.58-4.38-9.58-9.8ZM269.54,322.71v-.22c0-4.33-2.54-7.85-7.01-7.85s-7.09,3.3-7.09,7.9v.22c0,4.68,3.11,7.88,7.15,7.88,4.3,0,6.96-3.25,6.96-7.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.47,312.99h3.28l5.98,15.08,5.79-15.08h3.25v19.35h-2.36v-16.3l-6.42,16.3h-.73l-6.63-16.3v16.3h-2.17v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.2,312.99h11.29v1.92h-8.93v6.58h7.2v1.92h-7.2v7.01h9.42v1.92h-11.77v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.96,326.44h2.27c.3,2.3,1.22,4.25,5.12,4.25,2.49,0,4.41-1.46,4.41-3.65s-1-3.11-4.68-3.71c-4.06-.62-6.47-1.9-6.47-5.33,0-2.98,2.57-5.25,6.23-5.25,3.87,0,6.28,1.89,6.66,5.33h-2.11c-.46-2.44-1.87-3.44-4.55-3.44s-4.03,1.33-4.03,3.14.7,2.87,4.66,3.46c4.3.68,6.58,1.98,6.58,5.63,0,3.25-2.84,5.71-6.69,5.71-5.17,0-7.04-2.84-7.39-6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.08,338.9h3.09l6.55,19.35h-2.33l-1.9-5.58h-7.99l-1.87,5.58h-2.22l6.66-19.35ZM176.16,350.82h6.71l-3.36-9.96-3.36,9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.67,348.7v-.22c0-5.74,3.84-9.88,9.09-9.88,4.03,0,7.44,2.14,7.85,6.33h-2.33c-.49-2.95-2.19-4.47-5.5-4.47-4.01,0-6.69,3.11-6.69,7.99v.22c0,4.93,2.49,7.9,6.66,7.9,3.17,0,5.36-1.6,5.85-4.74h2.19c-.68,4.47-3.76,6.66-8.09,6.66-5.6,0-9.04-3.84-9.04-9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.73,338.9h3.09l6.55,19.35h-2.33l-1.9-5.58h-7.99l-1.87,5.58h-2.22l6.66-19.35ZM215.81,350.82h6.71l-3.36-9.96-3.36,9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.35,338.9h5.12c6.66,0,9.8,4.11,9.8,9.5v.24c0,5.36-3.09,9.61-9.85,9.61h-5.06v-19.35ZM237.35,356.34c4.98,0,7.47-2.98,7.47-7.71v-.22c0-4.47-2.17-7.61-7.5-7.61h-2.63v15.54h2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.76,338.9h11.29v1.92h-8.93v6.58h7.2v1.92h-7.2v7.01h9.42v1.92h-11.77v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.64,338.9h3.28l5.98,15.08,5.79-15.08h3.25v19.35h-2.36v-16.3l-6.42,16.3h-.73l-6.63-16.3v16.3h-2.17v-19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.04,349.81l-6.47-10.91h2.65l5.06,8.99,4.87-8.99h2.35l-6.12,10.94v8.42h-2.36v-8.45Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.44,80.94h-30.48c-4.27,0-6.02,2.71-6.02,2.71v-20.15c0-2.69,2.18-4.87,4.87-4.87h31.63v22.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.26,92.05c0,1.34.54,2.55,1.42,3.43.88.88,2.09,1.42,3.43,1.42h27.33v3.55h-28.1c-2.32,0-4.42-.94-5.94-2.46-1.52-1.52-2.46-3.62-2.46-5.94,0-4.64,3.76-8.4,8.4-8.4h28.1v3.55h-27.33c-2.68,0-4.85,2.17-4.85,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.36,90.28h28.08v3.55h-28.08c-.47,0-.85-.38-.85-.85v-1.84c0-.47.38-.85.85-.85Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.44,308.5h-30.48c-4.27,0-6.02,2.71-6.02,2.71v-20.15c0-2.69,2.18-4.87,4.87-4.87h31.63v22.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.26,319.6c0,1.34.54,2.55,1.42,3.43.88.88,2.09,1.42,3.43,1.42h27.33v3.55h-28.1c-2.32,0-4.42-.94-5.94-2.46-1.52-1.52-2.46-3.62-2.46-5.94,0-4.64,3.76-8.4,8.4-8.4h28.1v3.55h-27.33c-2.68,0-4.85,2.17-4.85,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.36,317.83h28.08v3.55h-28.08c-.47,0-.85-.38-.85-.85v-1.84c0-.47.38-.85.85-.85Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.23,300.07c0-2.1,0-4.2,0-6.3,0-.65.47-1.06,1.07-.93.38.08.66.4.68.79,0,.09,0,.19,0,.28,0,4.03,0,8.06,0,12.1,0,.74.32,1.06,1.06,1.07,1.4,0,2.79,0,4.19,0,.2,0,.29-.06.38-.24.54-1.15,1.79-1.75,3.01-1.45,1.25.3,2.09,1.37,2.06,2.63-.03,1.26-.93,2.35-2.16,2.6-1.19.24-2.41-.38-2.92-1.5-.08-.18-.18-.24-.37-.24-1.43,0-2.87.01-4.3,0-1.34,0-2.39-.88-2.65-2.19-.04-.21-.04-.43-.04-.64,0-1.99,0-3.98,0-5.96ZM113.04,308.84c.49,0,.86-.38.85-.88,0-.49-.38-.86-.88-.86-.49,0-.87.39-.86.88,0,.48.39.86.89.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.89,314.16c0,2.69,0,5.38,0,8.08,0,.39-.22.72-.58.85-.34.13-.75.04-.97-.26-.1-.14-.16-.31-.2-.48-.03-.11-.01-.24-.01-.36,0-5.15,0-10.3,0-15.45,0-.09,0-.19,0-.28-.02-.6-.36-.93-.96-.93-2.8,0-5.59,0-8.39,0-.15,0-.3,0-.45,0-.57-.01-.95-.37-.95-.9,0-.52.38-.88.96-.88,2.95,0,5.91,0,8.86,0,1.53,0,2.67,1.18,2.67,2.71,0,2.64,0,5.27,0,7.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.44,300.83c0-1.34-1.03-2.49-2.37-2.58-.93-.06-1.87-.03-2.81-.03-.18,0-.28-.04-.36-.22-.47-1.03-1.43-1.61-2.57-1.55-1.08.06-1.87.6-2.3,1.58-.44,1-.3,1.98.41,2.81.7.82,1.61,1.1,2.66.85.93-.22,1.53-.82,1.9-1.7.97,0,1.93-.02,2.9.01.19,0,.4.15.56.28.23.2.23.5.23.78,0,6.98,0,13.96,0,20.93,0,.12-.02.25.01.36.05.17.1.35.2.48.22.29.62.38.97.26.35-.13.57-.45.57-.85,0-3.24,0-6.49,0-9.74,0-3.89,0-7.78,0-11.68ZM93.46,299.97c-.47-.01-.86-.42-.86-.9,0-.49.39-.85.89-.84.46,0,.86.42.85.87,0,.46-.43.88-.89.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.39,311.6c0-1.28-.82-2.37-2.04-2.63-.47-.1-.97-.07-1.45-.08-.18,0-.26-.05-.33-.22-.53-1.18-1.8-1.81-3.04-1.51-1.16.27-2.01,1.27-2.07,2.44-.06,1.22.67,2.32,1.8,2.7,1.13.38,2.45.02,3.04-1.02.34-.6.73-.68,1.29-.63.08,0,.17,0,.25.01.36.04.64.29.72.65.03.15.04.3.04.45,0,3.41,0,6.83,0,10.24,0,.11,0,.23,0,.34.03.4.31.7.69.78.59.11,1.1-.33,1.1-.97,0-1.76,0-3.53,0-5.29,0-1.75,0-3.51,0-5.26ZM88.12,310.61c-.47,0-.88-.43-.87-.9.01-.47.39-.84.87-.84.48,0,.88.39.88.87,0,.47-.42.88-.88.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.02,311.41c-1.28-.26-2.48.34-3.01,1.52-.08.18-.18.22-.36.22-.41,0-.83-.03-1.23.04-1.31.24-2.16,1.28-2.18,2.62-.01,1.03,0,2.06,0,3.1,0,1.12,0,2.23,0,3.35,0,.49.31.83.77.89.58.07,1.03-.36,1.03-1.02,0-2.09,0-4.18,0-6.27,0-.59.35-.94.95-.94.21,0,.41.01.62,0,.22-.02.34.05.44.27.52,1.15,1.81,1.75,3.04,1.45,1.22-.29,2.08-1.41,2.05-2.66-.03-1.25-.91-2.31-2.1-2.55ZM109.44,314.9c-.49,0-.85-.39-.85-.89,0-.5.37-.86.88-.86.5,0,.87.37.86.85,0,.51-.4.91-.89.9Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.13,
    y: 63.22,
    width: 1.88,
    height: 18.18,
    rx: 0.73,
    ry: 0.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 106.46,
    y: 76.2,
    width: 1.88,
    height: 8.53,
    rx: 0.73,
    ry: 0.73,
    transform: "translate(26.93 187.86) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.31,77.68c-1.54,0-2.79,1.25-2.79,2.79s1.25,2.79,2.79,2.79,2.79-1.25,2.79-2.79-1.25-2.79-2.79-2.79ZM113.31,81.83c-.75,0-1.36-.61-1.36-1.36s.61-1.36,1.36-1.36,1.36.61,1.36,1.36-.61,1.36-1.36,1.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 99.65,
    y: 72.09,
    width: 1.88,
    height: 25.53,
    rx: 0.73,
    ry: 0.73,
    transform: "translate(201.17 169.71) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 97.16,
    y: 69.81,
    width: 1.88,
    height: 6.45,
    rx: 0.73,
    ry: 0.73,
    transform: "translate(171.13 -25.06) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.23,75.82c1.54,0,2.79-1.25,2.79-2.79s-1.25-2.79-2.79-2.79-2.79,1.25-2.79,2.79,1.25,2.79,2.79,2.79ZM93.23,71.67c.75,0,1.36.61,1.36,1.36s-.61,1.36-1.36,1.36-1.36-.61-1.36-1.36.61-1.36,1.36-1.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 96.09,
    y: 76.94,
    width: 1.88,
    height: 20.68,
    rx: 0.73,
    ry: 0.73,
    transform: "translate(194.06 174.56) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.44,
    y: 71.5,
    width: 1.88,
    height: 12.76,
    rx: 0.73,
    ry: 0.73,
    transform: "translate(169.26 -13.5) rotate(90)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 92.43,
    y: 81.69,
    width: 1.88,
    height: 15.93,
    rx: 0.73,
    ry: 0.73,
    transform: "translate(186.73 179.31) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.82,
    y: 80.29,
    width: 1.88,
    height: 4.67,
    rx: 0.73,
    ry: 0.73,
    transform: "translate(174.39 -9.14) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.79,85.41c1.54,0,2.79-1.25,2.79-2.79s-1.25-2.79-2.79-2.79-2.79,1.25-2.79,2.79,1.25,2.79,2.79,2.79ZM87.79,81.26c.75,0,1.36.61,1.36,1.36s-.61,1.36-1.36,1.36-1.36-.61-1.36-1.36.61-1.36,1.36-1.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.13,
    y: 85.84,
    width: 1.88,
    height: 11.78,
    rx: 0.73,
    ry: 0.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 104.61,
    y: 84.56,
    width: 1.88,
    height: 4.43,
    rx: 0.73,
    ry: 0.73,
    transform: "translate(192.32 -18.78) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.13,86.77c0-1.54-1.25-2.79-2.79-2.79s-2.79,1.25-2.79,2.79c0,1.54,1.25,2.79,2.79,2.79s2.79-1.25,2.79-2.79ZM110.71,86.77c0,.75-.61,1.36-1.36,1.36s-1.36-.61-1.36-1.36.61-1.36,1.36-1.36,1.36.61,1.36,1.36Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.111eec796693bc024ab3c5d5b1bb310b.svg";
export { ForwardRef as ReactComponent };